import { head } from 'ramda'

export function getEnvironment(): string {
	return head(window.location.host.split('.')) || ''
}
